import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useProducto } from "../../../../context/ProductoContext";

export default function DetalleProducto() {
    const { productoSeleccionado, modalOpenDetalleProducto, handleOpenDetalleProducto } = useProducto();

    return (
        <MeditocModal
            title="Detalle de producto"
            open={modalOpenDetalleProducto}
            setopen={handleOpenDetalleProducto}
            okmessage="Cerrar detalle"
            size="small"
            hidecancel
        >
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="ID de producto:" value={productoSeleccionado.iIdProducto} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Nombre:" value={productoSeleccionado.sNombre} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Nombre corto:" value={productoSeleccionado.sNombreCorto} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Tipo de producto:" value={productoSeleccionado.sTipoProducto} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Grupo:" value={productoSeleccionado.sGrupoProducto} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Descripción:" value={productoSeleccionado.sDescripcion} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Costo:" value={productoSeleccionado.sCosto} />
                </Grid>
                {productoSeleccionado.iFrecuencia > 0 && (
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField
                            label={productoSeleccionado.sIntervaloDisplay + " de vigencia:"}
                            value={productoSeleccionado.iFrecuencia}
                        />
                    </Grid>
                )}
                {productoSeleccionado.iIdGrupoProducto === 1 && productoSeleccionado.iIdTipoProducto !== 2 && (
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Sin anuncios:" value={productoSeleccionado.bPremium ? "Si" : "No"} />
                    </Grid>
                )}
                {productoSeleccionado.bComercial && (
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField
                            label="Visibilidad:"
                            value={
                                productoSeleccionado.iVisiblePremium === null
                                    ? "Sin visibilidad"
                                    : productoSeleccionado.iVisiblePremium === 0
                                    ? "Free y Premium"
                                    : productoSeleccionado.iVisiblePremium === 1
                                    ? "Free"
                                    : productoSeleccionado.iVisiblePremium === 2
                                    ? "Premium"
                                    : ""
                            }
                        />
                    </Grid>
                )}
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField
                        label="Orientaciones médicas:"
                        value={
                            productoSeleccionado.iOrientacion === null
                                ? "Sin Accesos"
                                : productoSeleccionado.iOrientacion == 0
                                ? "Ilimitados"
                                : productoSeleccionado.iOrientacion
                        }
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField
                        label="Asistencias psicólogicas:"
                        value={
                            productoSeleccionado.iPsicologica == null
                                ? "Sin Accesos"
                                : productoSeleccionado.iPsicologica == 0
                                ? "Ilimitados"
                                : productoSeleccionado.iPsicologica
                        }
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField
                        label="Especialista psicólogo:"
                        value={
                            productoSeleccionado.iConsultaPsicologica == null
                                ? "Sin Accesos"
                                : productoSeleccionado.iConsultaPsicologica == 0
                                ? "Ilimitados"
                                : productoSeleccionado.iConsultaPsicologica
                        }
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField
                        label="Ícono:"
                        value={
                            <i
                                className="icon size-20"
                                dangerouslySetInnerHTML={{
                                    __html: `&#x${productoSeleccionado.sIcon};`,
                                }}
                            />
                        }
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Comercial:" value={productoSeleccionado.sComercial} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Prefijo para folios:" value={productoSeleccionado.sPrefijoFolio} />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
